import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import Button from "../Buttons/Button";

const Modal = ({
  children,
  isOpen,
  onClose,
  width = "max-w-md",
  title,
  showCloseButton = true,
  closeOnOutsideClick = false,
  zIndex = 52,
  button,
  titleColor,
  wrapperClassName = "",
  panelClassName = "",
  bodyClassName = "p-4 flex-1 overflow-auto",
  backBlur = 2,
}) => {
  const handleBackdropClick = (e) => {
    if (closeOnOutsideClick) {
      onClose();
    }
  };

  return (
    <AnimatePresence mode="wait">
      {isOpen && (
        <div
          key="modal"
          className="fixed inset-0 overflow-y-auto"
          style={{ zIndex }}
          role="dialog"
        >
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={handleBackdropClick}
            className={`fixed inset-0 bg-[#000000]/70 bg-opacity-70 transition-opacity backdrop-blur-[${backBlur}px]`}
          />
          {/* Modal */}
          <div
            className={`flex min-h-screen items-center justify-center p-4 ${wrapperClassName}`}
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{
                type: "spring",
                stiffness: 400,
                damping: 40,
              }}
              className={`${width} w-full bg-white rounded-lg shadow-xl relative max-h-[90vh] overflow-hidden flex flex-col ${panelClassName}`}
            >
              {/* Rest of the modal content remains the same */}
              {/* Header */}
              {(title || showCloseButton) && (
                <div className="flex items-center justify-between px-4 py-1 bg-[#f9f9f9] shadow-md">
                  {title && (
                    <h2
                      className={`text-xl font-medium text-${
                        titleColor || `gray-900`
                      }`}
                    >
                      {title}
                    </h2>
                  )}
                  {showCloseButton && (
                    <Button
                      type="icon"
                      variant="text"
                      color="black"
                      onClick={onClose}
                      icon={"close"}
                    />
                  )}
                </div>
              )}

              {/* Content */}
              <div className={bodyClassName}>{children}</div>
            </motion.div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
